import { AssignColumnControl } from "../subcontrol/AssignColumnControl";
import { AssignStationControl } from "../subcontrol/AssignStationControl";
import { AssembleRoofSlapControl } from "../subcontrol/AssembleRoofSlapControl";
import { DrawSectionControl } from "../subcontrol/DrawSectionControl";
import { AssignEavesBoardControl } from "../subcontrol/AssignEavesBoardControl";
import { AssignGutterControl } from "../subcontrol/AssignGutterControl";
import { SelectGutterMonitorObjectControl } from "../subcontrol/SelectGutterMonitorObjectControl";
import { SelectRoofSlapMonitorObjectControl } from "../subcontrol/SelectRoofSlapMonitorObjectControl";
import { AddBuildingComponentControl } from "../subcontrol/AddBuildingComponentControl";
import { SelectWindLocationControl } from "../subcontrol/SelectWindLocationControl";

export const ARCHI_SUB_CONTROL = {
    /**
     * 布置站台二级控制器
     */
    ASSIGNSTATIONCONTROL: { name: "ASSIGNSTATIONCONTROL", needInit: true, cmd: "AssignStationControl", clazz: AssignStationControl },
    /**
     * 布置柱二级控制器
     */
    ASSIGNCOLUMNCONTROL: { name: "ASSIGNCOLUMNCONTROL", needInit: true, cmd: "AssignColumnControl", clazz: AssignColumnControl },
    /**
     * 绘制屋面板截面控制器
     */
    DRAWSECTIONCONTROL: { name: "DRAWSECTIONCONTROL", cmd: "DrawSectionControl", clazz: DrawSectionControl },
    /**
     * 布置屋面板控制器
     */
    ASSEMBLEROOFSLAP: { name: "ASSEMBLEROOFSLAP", cmd: "AssembleRoofSlapControl", clazz: AssembleRoofSlapControl },
    /**
     * 布置檐口板二级控制器
     */
    ASSIGNEAVESBOARDCONTROL: { name: "ASSIGNEAVESBOARDCONTROL", cmd: "AssignEavesBoardControl", clazz: AssignEavesBoardControl },
    /**
     * 布置天沟二级控制器
     */
    ASSIGNGUTTERCONTROL: { name: "ASSIGNGUTTERCONTROL", needInit: true, cmd: "AssignGutterControl", clazz: AssignGutterControl },
    // /**
    //  * 覆盖array二级控制器
    //  */
    // ARRAY: { name: "ARRAY", cmd: "ArrayControl", clazz: MonixArrayControl },
    /**
    * 添加天沟监测对象二级控制器
    */
    SELECTGUTTERMONITOROBJECT: { name: "SELECTGUTTERMONITOROBJECT", cmd: "SelectGutterMonitorObjectControl", clazz: SelectGutterMonitorObjectControl },
    /**
    * 添加屋面板监测对象二级控制器
    */
    SELECTROOFSLAPMONITOROBJECT: { name: "SELECTROOFSLAPMONITOROBJECT", cmd: "SelectRoofSlapMonitorObjectControl", clazz: SelectRoofSlapMonitorObjectControl },
    /**
    * 添加风位监测对象二级控制器
    */
    SELECTWINDLOCATIONMONITOROBJECT: { name: "SELECTWINDLOCATIONMONITOROBJECT", cmd: "SelectWindLocationControl", clazz: SelectWindLocationControl },

    /**
     * 布置路灯、树等组件二级控制器
     */
    ADDBUILDINGCOMPONENTCONTROL: { name: "ADDBUILDINGCOMPONENTCONTROL", cmd: "AddBuildingComponentControl", clazz: AddBuildingComponentControl },
}